export default function (promise: Promise<any>,
                         message?: string,
                         timeout: number = 5000,
): Promise<any> {
    let timer: number;
    return Promise.race([
        // @ts-ignore
        promise,
        new Promise((_r, rej) => timer = setTimeout(() => rej(message || 'Promise Timeout'), timeout))
    ]).finally(() => clearTimeout(timer));
}